/* ─── HoneyBiotics custom cart drawer ─────────────────────────────────────── */
(function () {
  'use strict';

  var root = document.getElementById('hbcd');
  var overlay = document.getElementById('hbcd-ov');
  if (!root || !overlay) return;

  var CFG = {};
  try {
    var cfgEl = document.getElementById('hbcd-cfg');
    CFG = JSON.parse((cfgEl && cfgEl.textContent) || '{}');
  } catch (_) {
    CFG = {};
  }
  var pathsEl = document.getElementById('hbcd-paths');
  var PATHS = [];
  if (pathsEl) {
    try {
      PATHS = JSON.parse(pathsEl.textContent || '[]').filter(function (p) {
        return p && p.tiers && p.tiers.length;
      });
    } catch (_) {
      PATHS = [];
    }
  }
  var FREE_THRESHOLD = resolveFreeThreshold();
  var CHECKOUT_URL = CFG.checkout_url || '/checkout';
  var CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONEY_FMT = CFG.money_format || '${{amount}}';
  var DEFAULT_IMG = CFG.product_img || '';
  var EMPTY_SHOP_URL = CFG.empty_shop_url || '/collections';
  var T = CFG.i18n || {};

  /* Theme threshold is shop currency (e.g. $99 AUD). Cart totals are presentment
     currency — multiply by Shopify.currency.rate (fallback: Liquid market rate). */
  function resolveFreeThreshold() {
    var shopCents = CFG.free_threshold_shop_cents != null
      ? CFG.free_threshold_shop_cents
      : 9900;
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate != null) {
      rate = parseFloat(Shopify.currency.rate) || 1;
    } else if (CFG.currency_rate != null) {
      rate = parseFloat(CFG.currency_rate) || 1;
    }
    return Math.round(shopCents * rate);
  }

  function hasPlaceholder(tpl, key) {
    return new RegExp('\\[\\s*' + key + '\\s*\\]|\\{\\{\\s*' + key + '\\s*\\}\\}').test(String(tpl));
  }

  function t(key, fallback, requiredKeys) {
    var v = T[key];
    if (v != null && String(v).trim() !== '') {
      if (!requiredKeys || !requiredKeys.length) return v;
      if (requiredKeys.every(function (k) { return hasPlaceholder(v, k); })) return v;
    }
    return fallback;
  }

  function fillTpl(tpl, vars) {
    return String(tpl)
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
        return vars[k] != null ? vars[k] : '';
      })
      .replace(/\[(\w+)\]/g, function (_, k) {
        return vars[k] != null ? vars[k] : '';
      });
  }

  var RM_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';

  var els = {};
  ['close', 'ct', 'shipmsg', 'shipbar', 'lines',
    'disc', 'disc-toggle', 'disc-wrap', 'disc-input', 'disc-apply', 'disc-msg', 'disc-applied', 'disc-text', 'disc-rm',
    'lv-sub', 'lr-bundle', 'lv-bundle', 'lr-disc', 'll-disc', 'lv-disc', 'lv-ship', 'r-tot',
    'co', 'eshop', 'empty-shop'].forEach(function (k) {
    els[k] = root.querySelector('[data-hbcd-' + k + ']');
  });

  var state = { cart: null, _opening: false, _upgrading: false };

  function money(cents) {
    var amt = (cents / 100).toFixed(2);
    var withComma = amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = MONEY_FMT.replace('{{amount}}', withComma)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', withComma.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());

    // applyCart sets this same fetched cart before rendering its amounts.
    var currency = state.cart && state.cart.currency;
    if (!/^[A-Z]{3}$/.test(currency || '')) return formatted;
    return new RegExp('\\b' + currency + '\\b', 'i').test(formatted)
      ? formatted
      : formatted + ' ' + currency;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function setTidioVisible(visible) {
    if (!isMobile()) return;
    var api = window.tidioChatApi;
    if (!api) return;
    try {
      if (visible) {
        if (typeof api.show === 'function') api.show();
      } else if (typeof api.hide === 'function') {
        api.hide();
      }
    } catch (_) {}
  }

  function showDrawer() {
    root.classList.add('hbcd-on');
    overlay.classList.add('hbcd-on');
    document.documentElement.classList.add('hbcd-locked');
    setTidioVisible(false);
  }

  function close() {
    root.classList.remove('hbcd-on');
    overlay.classList.remove('hbcd-on');
    document.documentElement.classList.remove('hbcd-locked');
    setTidioVisible(true);
  }

  function open() {
    fetchCart().then(showDrawer);
  }

  function applyCart(cart) {
    if (!cart) return;
    state.cart = cart;
    var signature = JSON.stringify(cart);
    if (signature !== lastRenderedCart) {
      render(cart);
      lastRenderedCart = signature;
    }
  }

  function cartHasItems(cart) {
    return !!(cart && cart.items && cart.items.length);
  }

  /* After ATC the theme already fetched cart.js into event.detail.cart.
     Use it immediately so the drawer never opens on a stale empty state.
     Only fall back to cart.js (with a short retry) when the event cart is a stub. */
  function openAfterAdd(cartHint) {
    if (state._opening) return;
    state._opening = true;
    suppressThemeCartDrawer();

    function done(cart) {
      applyCart(cart);
      showDrawer();
      state._opening = false;
    }

    if (cartHasItems(cartHint)) {
      done(cartHint);
      /* Background sync only — never overwrite items with a stale empty cart.js. */
      getCart().then(function (cart) {
        if (cartHasItems(cart)) applyCart(cart);
      }).catch(function () {});
      return;
    }

    /* Use getCart (not fetchCart) so a stale empty response is not painted
       before retries finish — avoids the empty-flash while the drawer opens. */
    getCart().then(function (cart) {
      if (cartHasItems(cart)) {
        done(cart);
        return null;
      }
      var attempts = 0;
      function retry() {
        attempts += 1;
        return getCart().then(function (c) {
          if (cartHasItems(c) || attempts >= 4) {
            done(c);
            return c;
          }
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(retry()); }, 120);
          });
        });
      }
      return retry();
    }).catch(function () {
      state._opening = false;
    });
  }

  root.addEventListener('click', function (e) { if ((offerBusy || offerBlocked || (window.HBOffer03Shipping && window.HBOffer03Shipping.busy())) && !e.target.closest('[data-hbcd-close]')) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  if (els.close) els.close.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('hbcd-on')) close();
  });

  function cartFetch(endpoint, body) {
    return fetch(CART_ROOT + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return null; }).then(function (payload) {
          var description = payload && (payload.description || payload.message);
          var error = new Error('We could not update your cart. Please reload and check your cart.');
          error.description = typeof description === 'string' ? description : '';
          error.status = r.status;
          error.endpoint = endpoint;
          error.knownRejected = r.status >= 400 && r.status < 500 && r.status !== 408;
          if (window.console && window.console.warn) window.console.warn('Cart update rejected', { endpoint: endpoint, status: r.status });
          throw error;
        });
      }
      return r.json();
    });
  }

  function getCart() {
    return fetch(CART_ROOT + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  var cartReadSequence = 0;
  var lastRenderedCart = null;
  function fetchCart() {
    var sequence = ++cartReadSequence;
    return getCart().then(function (cart) {
      if (sequence !== cartReadSequence) return state.cart || cart;
      applyCart(cart);
      return cart;
    });
  }

  var OFFER = [];
  try { OFFER = JSON.parse((document.getElementById('hbcd-offer03-data') || {}).textContent || '[]'); } catch (_) {}
  var offerBusy = false;
  var offerBlocked = false;
  var offerError = '';
  function sameOfferProperties(left, right) {
    function normalized(value) { return Object.keys(value || {}).sort().map(function (key) { return [key, value[key]]; }); }
    return JSON.stringify(normalized(left)) === JSON.stringify(normalized(right));
  }
  function otherOfferLinesChanged(before, after, source) {
    return before.items.filter(function (line) { return line !== source; }).some(function (line) {
      return !after.items.some(function (current) { return Number(current.variant_id) === Number(line.variant_id) && current.quantity === line.quantity && sameOfferProperties(current.properties, line.properties) && (lineHasSubscription(current) ? current.selling_plan_allocation.selling_plan.id : null) === (lineHasSubscription(line) ? line.selling_plan_allocation.selling_plan.id : null); });
    });
  }
  async function offerWrite(endpoint, body) {
    try { return await cartFetch(endpoint, body); }
    catch (error) { if (!error.knownRejected) error.offerMutationUncertain = true; throw error; }
  }
  function offerPack(line) {
    if (!line || !line.properties || line.properties._hb_offer03 !== 'v1' || !line.properties._hb_offer_line) return null;
    return OFFER.find(function (p) { return Number(p.id) === Number(line.variant_id); }) || null;
  }
  function offerPlan(pack, weeks) {
    var plans = (pack.plans || []).filter(function (p) { return Number(p.weeks) === Number(weeks); });
    return plans.length === 1 ? plans[0] : null;
  }
  function offerWeeks(line, pack) {
    var id = lineHasSubscription(line) && line.selling_plan_allocation.selling_plan.id;
    var plan = (pack.plans || []).find(function (p) { return Number(p.id) === Number(id); });
    return plan ? plan.weeks : Number(line.properties._hb_offer_weeks || 4);
  }
  function offerLabel(pack) { return pack.qty === 1 ? '1 Tube' : pack.qty === 3 ? 'Buy 2 Get 1 Free' : 'Buy 3 Get 2 Free'; }
  function offerCompare(pack) { return Math.max(pack.compare || 0, pack.price || 0); }
  function offerPrice(pack, weeks, subscribed) {
    var plan = subscribed && offerPlan(pack, weeks);
    return subscribed ? (plan ? plan.price : null) : pack.price;
  }
  function buildOfferHtml(line, pack) {
    var sub = lineHasSubscription(line), weeks = offerWeeks(line, pack), qty = line.quantity;
    var price = line.final_line_price, compare = offerCompare(pack) * qty;
    var shippingPreparing = window.HBOffer03Shipping && window.HBOffer03Shipping.busy && window.HBOffer03Shipping.busy();
    var dis = offerBusy || offerBlocked || shippingPreparing ? ' disabled' : '';
    var picker = pack.qty === 1 ? '1 Tube' : '<select class="hbc-pick" data-hb-offer-action="bundle" aria-label="Offer"' + dis + '>' + OFFER.filter(function (p) { return p.qty > 1; }).map(function (p) {
      return '<option value="' + p.id + '"' + (p.id === pack.id ? ' selected' : '') + (!p.available || (sub && !offerPlan(p, weeks)) ? ' disabled' : '') + '>' + offerLabel(p) + '</option>';
    }).join('') + '</select>';
    var item = '<div class="hbc-item"><div class="hbc-thumb"><img src="' + escapeHtml(line.image || pack.image) + '" alt="' + escapeHtml(pack.title) + '" width="72" height="72"></div><div><div class="hbc-name">' + escapeHtml(pack.title) + '</div><div class="hbc-variant">' + picker + '</div>' + (pack.qty > 1 ? '<div class="hbc-free">' + pack.qty + ' tubes, ' + (pack.qty === 3 ? 1 : 2) + ' free</div>' : '') + (qty > 1 ? '<div class="hbc-free">' + qty + ' packs</div>' : '') + '</div><div class="hbc-price"><b>' + money(price) + '</b>' + (compare > price ? '<s>' + money(compare) + '</s>' : '') + '<button type="button" class="hbc-remove" data-hbcd-rm aria-label="Remove ' + escapeHtml(pack.title) + '"' + dis + '>' + RM_SVG + '</button></div></div>';
    var html = '<div class="hbc hbcd-offer-line" data-line-key="' + escapeHtml(line.key) + '">';
    if (pack.qty === 1) {
      var next = OFFER.find(function (p) { return p.qty === 3; });
      var to = next && offerPrice(next, weeks, sub);
      var available = next && next.available && to !== null;
      html += '<div class="hbc-card">' + item + '<div class="hbc-upgrade"><div class="hbc-upgrade-text"><span class="hbc-tag">+1 FREE TUBE</span><b>Black Friday: Upgrade to Buy 2 Get 1 Free &amp; Free Shipping</b>' + (available ? '<small>3 tubes for <em>' + money(to) + '</em> <s>' + money(offerCompare(next)) + '</s> <span class="hbc-save">Save ' + money(Math.max(0, offerCompare(next) - to)) + '</span></small>' : '<small>This offer is unavailable for your selected frequency.</small>') + '</div><button type="button" class="hbc-upgrade-btn" data-hb-offer-action="upgrade"' + (offerBusy || offerBlocked || shippingPreparing || !available ? ' disabled' : '') + '>Upgrade now</button></div></div>';
    } else if (pack.qty === 3) {
      var switchPack = OFFER.find(function (p) { return p.qty === 5; });
      var canSwitch = switchPack && switchPack.available && (!sub || offerPlan(switchPack, weeks));
      html += '<div class="hbc-card">' + item + '<div class="hbc-upgrade"><div class="hbc-upgrade-text"><b>Want more? Switch to Buy 3 Get 2 Free</b></div><button type="button" class="hbc-upgrade-btn" data-hb-offer-action="bundle" data-hb-offer-target="' + (switchPack ? switchPack.id : '') + '"' + (offerBusy || offerBlocked || shippingPreparing || !canSwitch ? ' disabled' : '') + '>Switch</button></div></div>';
    } else html += item;
    var selectedPlan = offerPlan(pack, weeks);
    var saving = selectedPlan && pack.price > 0 ? Math.round(100 * (pack.price - selectedPlan.price) / pack.price) : 0;
    var inputId = 'hb-offer-refills-' + line.properties._hb_offer_line;
    html += '<div class="hbc-refills' + (sub ? ' is-on' : '') + '" data-hb-offer-refills><span class="hbc-check"><input type="checkbox" id="' + escapeHtml(inputId) + '" data-hb-offer-action="subscribe"' + (sub ? ' checked' : '') + (offerBusy || offerBlocked || shippingPreparing || !selectedPlan ? ' disabled' : '') + '><span class="hbc-box"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span></span><div class="hbc-refills-text"><label for="' + escapeHtml(inputId) + '">' + (saving > 0 ? 'Save ' + saving + '% with automatic refills' : 'Automatic refills') + '</label><p>' + pack.qty + (pack.qty === 1 ? ' tube' : ' tubes (' + (pack.qty === 3 ? 1 : 2) + ' free)') + ' delivered every <select class="hbc-pick" data-hb-offer-action="frequency" aria-label="Delivery frequency"' + dis + '>' + (!selectedPlan ? '<option value="" selected>Choose frequency</option>' : '') + (pack.plans || []).filter(function (p) { return offerPlan(pack, p.weeks) === p; }).map(function (p) { return '<option value="' + p.weeks + '"' + (Number(p.weeks) === Number(weeks) ? ' selected' : '') + '>' + p.weeks + ' weeks</option>'; }).join('') + '</select></p><p>Pause, skip or cancel anytime.</p></div></div></div>';
    return html;
  }
  function findOfferLine(cart, token, variant, planId) {
    return (cart.items || []).find(function (line) {
      var plan = lineHasSubscription(line) ? Number(line.selling_plan_allocation.selling_plan.id) : null;
      return offerPack(line) && line.properties._hb_offer_line === token && Number(line.variant_id) === Number(variant) && plan === planId;
    });
  }
  async function changeOffer(lineKey, action, value) {
    if (offerBusy || offerBlocked || (window.HBOffer03Shipping && window.HBOffer03Shipping.busy && window.HBOffer03Shipping.busy())) return;
    offerBusy = true; offerError = '';
    root.dataset.offerUpdating = 'true';
    if (els.co) els.co.disabled = true;
    if (state.cart) render(state.cart);
    var before, source, attempted, token, oldPlan, targetPlan, targetPack, properties, inPlace;
    try {
      before = await getCart();
      source = before.items.find(function (line) { return line.key === lineKey; });
      var pack = offerPack(source);
      if (!pack) throw new Error('Your cart changed. Please choose the offer again.');
      token = source.properties._hb_offer_line;
      oldPlan = lineHasSubscription(source) ? Number(source.selling_plan_allocation.selling_plan.id) : null;
      var weeks = offerWeeks(source, pack), subscribed = !!oldPlan;
      targetPack = pack;
      if (action === 'upgrade') targetPack = OFFER.find(function (p) { return p.qty === 3; });
      if (action === 'bundle') targetPack = OFFER.find(function (p) { return p.qty > 1 && Number(p.id) === Number(value); });
      if (action === 'subscribe') subscribed = value;
      if (action === 'frequency') { weeks = Number(value); subscribed = true; }
      var allocation = targetPack && offerPlan(targetPack, weeks);
      if (!targetPack || !targetPack.available || (subscribed && !allocation)) throw new Error('This offer is unavailable for your selected frequency. Your cart was kept.');
      targetPlan = subscribed ? Number(allocation.id) : null;
      properties = Object.assign({}, source.properties, { _hb_offer_weeks: String(weeks) });
      inPlace = Number(targetPack.id) === Number(source.variant_id) && targetPlan === oldPlan;
      if (inPlace) {
        attempted = true;
        await offerWrite('cart/change.js', { line: before.items.indexOf(source) + 1, quantity: source.quantity, properties: properties });
      } else {
        var item = { id: targetPack.id, quantity: source.quantity, properties: properties };
        if (targetPlan) item.selling_plan = targetPlan;
        attempted = true;
        await offerWrite('cart/add.js', { items: [item] });
        var interim = await getCart();
        var currentSource = findOfferLine(interim, token, source.variant_id, oldPlan);
        var currentTarget = findOfferLine(interim, token, targetPack.id, targetPlan);
        if (!currentSource || !currentTarget || currentTarget.quantity !== source.quantity) throw new Error('We could not confirm the replacement. Please check your cart.');
        await offerWrite('cart/change.js', { line: interim.items.indexOf(currentSource) + 1, quantity: 0 });
      }
      var after = await getCart();
      var result = findOfferLine(after, token, targetPack.id, targetPlan);
      if (!result || result.quantity !== source.quantity || !sameOfferProperties(result.properties, properties)) throw new Error('We could not confirm your offer change. Please check your cart.');
      var sourceStillPresent = !inPlace && findOfferLine(after, token, source.variant_id, oldPlan);
      if (sourceStillPresent) throw new Error('Your replacement did not finish. Your original offer will be restored.');
      var lostCode = (before.discount_codes || []).some(function (code) {
        return !(after.discount_codes || []).some(function (current) { return current.code.toUpperCase() === code.code.toUpperCase() && (!code.applicable || current.applicable || code.code.toUpperCase() === 'HB-AU-B2G1-SHIP'); });
      });
      if (lostCode) throw new Error('Your discount does not carry to this choice. Your original offer will be restored.');
      var changedOtherLine = otherOfferLinesChanged(before, after, source);
      if (changedOtherLine) throw new Error('Your cart changed during this update. Please check your cart.');
      applyCart(after);
      var wasShippingEligible = pack.qty === 3 && !oldPlan;
      var nowShippingEligible = targetPack.qty === 3 && !subscribed;
      if (window.HBOffer03Shipping && wasShippingEligible !== nowShippingEligible) window.HBOffer03Shipping.intent(nowShippingEligible, nowShippingEligible);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      if (attempted && source) {
        try {
          var recovery = await getCart();
          var keptSource = findOfferLine(recovery, token, source.variant_id, oldPlan);
          if (inPlace) {
            var changed = keptSource;
            if (!changed) throw new Error('Missing source');
            await offerWrite('cart/change.js', { line: recovery.items.indexOf(changed) + 1, quantity: source.quantity, properties: source.properties });
          } else {
            if (!keptSource) {
              var restore = { id: source.variant_id, quantity: source.quantity, properties: source.properties };
              if (oldPlan) restore.selling_plan = oldPlan;
              await offerWrite('cart/add.js', { items: [restore] });
              recovery = await getCart();
              keptSource = findOfferLine(recovery, token, source.variant_id, oldPlan);
            }
            if (!keptSource || keptSource.quantity !== source.quantity) throw new Error('Unconfirmed source');
            var extra = findOfferLine(recovery, token, targetPack.id, targetPlan);
            if (extra) await offerWrite('cart/change.js', { line: recovery.items.indexOf(extra) + 1, quantity: 0 });
          }
          var restored = await getCart();
          var original = findOfferLine(restored, token, source.variant_id, oldPlan);
          if (!original || original.quantity !== source.quantity || !sameOfferProperties(original.properties, source.properties)) throw new Error('Unconfirmed restoration');
          if (!inPlace && findOfferLine(restored, token, targetPack.id, targetPlan)) throw new Error('Replacement removal uncertain');
          var discountsRestored = (before.discount_codes || []).every(function (code) { return (restored.discount_codes || []).some(function (current) { return current.code.toUpperCase() === code.code.toUpperCase() && (!code.applicable || current.applicable); }); });
          if (!discountsRestored) throw new Error('Discount restoration uncertain');
          if (otherOfferLinesChanged(before, restored, source)) throw new Error('Other cart changes need review');
        } catch (_) { offerBlocked = true; error = new Error('We could not confirm recovery. Please reload and check your cart before checkout.'); }
      }
      if (error.offerMutationUncertain) { offerBlocked = true; error = new Error('The connection was interrupted during your update. Please reload and check your cart before checkout.'); }
      offerError = error.message || 'Could not update your offer. Please retry.';
      await fetchCart().catch(function () {});
    } finally {
      offerBusy = false;
      root.dataset.offerUpdating = 'false';
      root.dataset.offerBlocked = offerBlocked ? 'true' : 'false';
      if (els.co) els.co.disabled = offerBlocked;
      if (state.cart) { render(state.cart); lastRenderedCart = JSON.stringify(state.cart); }
    }
  }

  function findLineMatch(line) {
    var vid = line.variant_id;
    var handle = line.handle || line.product_handle || '';
    var title = ((line.variant_title || '') + ' ' + (line.product_title || '') + ' ' + (line.title || '')).toLowerCase();

    for (var p = 0; p < PATHS.length; p++) {
      var path = PATHS[p];
      var tiers = path.tiers || [];

      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].id && tiers[i].id == vid) {
          return { path: path, tierIndex: i, tier: tiers[i] };
        }
      }

      if (handle && handle === path.base_handle && tiers[0]) {
        return { path: path, tierIndex: 0, tier: tiers[0] };
      }

      if (path.bundle_handle && handle === path.bundle_handle) {
        for (var j = tiers.length - 1; j >= 1; j--) {
          var qtyStr = String(tiers[j].qty || '');
          if (qtyStr && title.indexOf(qtyStr) > -1) {
            return { path: path, tierIndex: j, tier: tiers[j] };
          }
        }
      }
    }
    return null;
  }

  function getNextTier(match) {
    if (!match || !match.path || !match.path.tiers) return null;
    var nextIndex = match.tierIndex + 1;
    if (nextIndex >= match.path.tiers.length) return null;
    var next = match.path.tiers[nextIndex];
    if (!next || !next.id) return null;
    return { path: match.path, tierIndex: nextIndex, tier: next };
  }

  /* Upsell rules (client):
     - CFG.show_upsell from Theme Editor checkbox (hide_upgrade_card) + NZ/SG hide
     - only 1 → show 1→3
     - only 3 → show 3→5
     - mixed tiers of the same product (e.g. 1+3) → no upsell
     - top pack → no upsell */
  function pathHasMixedTiers(cart, path) {
    if (!path) return false;
    var seen = {};
    var count = 0;
    (cart.items || []).forEach(function (line) {
      var m = findLineMatch(line);
      if (!m || !m.path || m.path.id !== path.id) return;
      var key = String(m.tierIndex);
      if (!seen[key]) {
        seen[key] = true;
        count += 1;
      }
    });
    return count > 1;
  }

  function shouldShowUpsell(cart, match) {
    if (CFG.show_upsell === false) return false;
    if (!match || !getNextTier(match)) return false;
    if (pathHasMixedTiers(cart, match.path)) return false;
    return true;
  }

  function lineHasSubscription(line) {
    return !!(line && line.selling_plan_allocation && line.selling_plan_allocation.selling_plan);
  }

  function linePricing(line, match) {
    var offer = offerPack(line);
    if (offer) return { price: line.original_line_price, compare: offerCompare(offer) * line.quantity, label: offerLabel(offer), savePct: 0, planName: '' };
    var hasSub = lineHasSubscription(line);
    var shopifyPrice = line.final_line_price != null ? line.final_line_price : line.line_price;
    var shopifyCompare = line.original_line_price != null ? line.original_line_price : shopifyPrice;

    /* Hardcoded pack prices are one-time only. Subscription lines must use
       Shopify final_line_price so the 15% selling-plan discount shows. */
    if (match && match.tier && !hasSub) {
      var tier = match.tier;
      var mult = match.path.id === 'clc-dedicated-im' ? line.quantity : (tier.qty === 1 ? line.quantity : 1);
      var oneTimeSavePct = tier.save_pct || 0;
      // Match the buy box's displayed bundle compare-at price in each market.
      if (match.path.bundle_handle === 'intense-moisturiser-bundle' && tier.compare > 0) {
        oneTimeSavePct = Math.max(0, Math.round(100 * (1 - tier.price / tier.compare)));
      }
      return {
        price: tier.price * mult,
        compare: (tier.compare || tier.price) * mult,
        label: tier.label,
        savePct: oneTimeSavePct,
        planName: ''
      };
    }

    var label = (match && match.tier && match.tier.label) || line.variant_title || '';
    var savePct = 0;
    if (shopifyCompare > shopifyPrice && shopifyCompare > 0) {
      savePct = Math.round(100 * (1 - shopifyPrice / shopifyCompare));
    }

    return {
      price: shopifyPrice,
      compare: shopifyCompare,
      label: label,
      savePct: savePct,
      planName: hasSub ? (line.selling_plan_allocation.selling_plan.name || 'Subscription') : ''
    };
  }

  function buildLineHtml(line, match) {
    var p = linePricing(line, match);
    var saveHtml = p.compare > p.price ? '<span class="hbcd-item__was">' + money(p.compare) + '</span>' : '';
    var youSave = p.compare > p.price
      ? '<span class="hbcd-item__you-save">' + escapeHtml(fillTpl(t('you_save', 'You save [amount]', ['amount']), { amount: money(p.compare - p.price) })) + '</span>'
      : '';
    var saveTag = p.savePct
      ? ' <span class="hbcd-item__save-tag">' + escapeHtml(fillTpl(t('save_tag', 'SAVE [pct]%', ['pct']), { pct: p.savePct })) + '</span>'
      : '';
    var label = p.label || line.variant_title || '';
    var planHtml = p.planName
      ? '<div class="hbcd-item__plan">' + escapeHtml(p.planName) + '</div>'
      : '';
    var img = line.image || (match && match.path && match.path.img) || DEFAULT_IMG;
    var title = line.product_title || '';

    return (
      '<div class="hbcd-item" data-line-key="' + line.key + '"' +
        (lineHasSubscription(line) ? ' data-has-sub="1"' : '') + '>' +
        '<div class="hbcd-item__img"><img src="' + img + '" alt="" width="72" height="72" loading="lazy"></div>' +
        '<div class="hbcd-item__mid">' +
          '<div class="hbcd-item__name">' + escapeHtml(title) + '</div>' +
          '<div class="hbcd-item__variant">' + escapeHtml(label) + saveTag + '</div>' +
          planHtml +
          '<div class="hbcd-qty">' +
            '<button type="button" data-hbcd-dec aria-label="Decrease quantity">−</button>' +
            '<span class="hbcd-qty__n">' + line.quantity + '</span>' +
            '<button type="button" data-hbcd-inc aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="hbcd-item__prices">' +
          '<span class="hbcd-item__now">' + money(p.price) + '</span>' +
          saveHtml + youSave +
          '<button type="button" class="hbcd-rm" data-hbcd-rm title="Remove">' + RM_SVG + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function buildUpsellHtml(lineKey, match) {
    var next = getNextTier(match);
    if (!next || !next.tier) return '';

    var path = match.path;
    var baseTier = path.tiers[0];
    var nextTier = next.tier;
    var compareCents = path.id === 'clc-dedicated-im' ? nextTier.compare : (baseTier ? baseTier.price : 0) * (nextTier.qty || 1);
    var savedCents = Math.max(0, compareCents - nextTier.price);
    var img = path.img || DEFAULT_IMG;
    var titleHtml = escapeHtml(fillTpl(t('upsell_title', '[qty] Tubes', ['qty']), { qty: nextTier.qty })) +
      ' <span>' + money(nextTier.price) + '</span> <s>' + money(compareCents) + '</s>';
    var benefit = escapeHtml(fillTpl(t('upsell_benefit', 'Save [amount] + FREE shipping', ['amount']), {
      amount: money(savedCents)
    }));

    if (path.id === 'clc-dedicated-im' && !nextTier.free_ship && nextTier.price < FREE_THRESHOLD) {
      benefit = 'Save ' + money(savedCents);
    }

    return (
      '<div class="hbcd-upsell" data-line-key="' + lineKey + '">' +
        '<img class="hbcd-upsell__img" src="' + img + '" alt="" width="46" height="46" loading="lazy">' +
        '<div class="hbcd-upsell__mid">' +
          '<div class="hbcd-upsell__title">' + titleHtml + '</div>' +
          '<div class="hbcd-upsell__benefit">' + benefit + '</div>' +
        '</div>' +
        '<button type="button" class="hbcd-upsell__btn" data-hbcd-upsell-btn>' +
          escapeHtml(t('upsell_btn', 'UPGRADE')) +
        '</button>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function codeDiscountApps(cart) {
    return (cart && cart.cart_level_discount_applications || []).filter(function (app) {
      return app.type === 'discount_code';
    });
  }

  function applicableDiscountCodes(cart) {
    return (cart && cart.discount_codes || []).filter(function (d) { return d.applicable; });
  }

  function formatDiscChip(app) {
    var title = app.title || '';
    if (app.value_type === 'percentage') {
      var pct = parseFloat(app.value);
      if (!isNaN(pct)) {
        var pctStr = pct % 1 === 0 ? String(Math.round(pct)) : String(pct);
        return title + ' (' + pctStr + '% off)';
      }
    }
    /* Fixed-amount value is in shop currency; total_allocated_amount is already
       in the customer's presentation currency — use that for the chip. */
    if (app.total_allocated_amount > 0) {
      return title + ' (' + money(app.total_allocated_amount) + ' off)';
    }
    if (app.value_type === 'fixed_amount') {
      var fixed = Math.round(parseFloat(app.value) * 100);
      if (!isNaN(fixed) && fixed > 0) return title + ' (' + money(fixed) + ' off)';
    }
    return title;
  }

  function discountChipLabel(cart) {
    var apps = codeDiscountApps(cart);
    if (apps.length) return formatDiscChip(apps[0]);
    var codes = applicableDiscountCodes(cart);
    if (codes.length) return codes[0].code;
    return '';
  }

  function discountAmount(cart) {
    return codeDiscountApps(cart).reduce(function (sum, app) {
      return sum + (app.total_allocated_amount || 0);
    }, 0);
  }

  function clearDiscError() {
    if (els['disc-input']) els['disc-input'].classList.remove('hbcd-disc--err');
    if (els['disc-msg']) {
      els['disc-msg'].textContent = '';
      els['disc-msg'].classList.remove('hbcd-disc--err-msg');
    }
  }

  function showDiscError() {
    if (els['disc-input']) els['disc-input'].classList.add('hbcd-disc--err');
    if (els['disc-msg']) {
      els['disc-msg'].textContent = t('disc_error', 'Invalid code — please check and try again.');
      els['disc-msg'].classList.add('hbcd-disc--err-msg');
    }
  }

  function hasAppliedDiscount(cart) {
    return codeDiscountApps(cart).length > 0 || applicableDiscountCodes(cart).length > 0;
  }

  function hasAppliedOfferDeal(cart) {
    return !!cart && (cart.items || []).some(function (line) {
      var pack = offerPack(line);
      return pack && line.quantity > 0 && typeof line.final_line_price === 'number' && line.final_line_price < offerCompare(pack) * line.quantity;
    });
  }
  function render(cart) {
    var bfDeal = root.querySelector('[data-hb-offer03-bf-deal]');
    if (bfDeal) bfDeal.hidden = !hasAppliedOfferDeal(cart);
    if (!els.lines) return;

    if (!cart.items || cart.items.length === 0) {
      root.classList.add('hbcd--empty');
      root.dataset.offerShipping = 'false';
      els.lines.innerHTML = '';
      updateCount(0);
      renderFooter(cart);
      return;
    }

    root.classList.remove('hbcd--empty');
    updateCount(cart.item_count);

    root.dataset.offerShipping = (cart.items || []).some(function (line) { var pack = offerPack(line); return pack && pack.qty === 3 && !lineHasSubscription(line); }) ? 'true' : 'false';
    var html = offerError ? '<p role="status" class="hbcd-offer-error">' + escapeHtml(offerError) + '</p>' : '';
    cart.items.forEach(function (line) {
      var offer = offerPack(line);
      if (offer) { html += '<div class="hbcd-line-group">' + buildOfferHtml(line, offer) + '</div>'; return; }
      var match = findLineMatch(line);
      html += '<div class="hbcd-line-group">';
      html += buildLineHtml(line, match);
      if (shouldShowUpsell(cart, match)) {
        html += buildUpsellHtml(line.key, match);
      }
      html += '</div>';
    });
    els.lines.innerHTML = html;
    renderFooter(cart);
  }

  function updateCount(count) {
    if (els.ct) {
      if (count > 0) {
        var word = count === 1
          ? t('item_singular', 'item')
          : t('item_plural', 'items');
        els.ct.textContent = '(' + count + ' ' + word + ')';
      } else {
        els.ct.textContent = '';
      }
    }
    document.querySelectorAll('cart-count').forEach(function (el) {
      var value = el.querySelector('span');
      if (!value) { value = document.createElement('span'); el.appendChild(value); }
      value.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderFooter(cart) {
    FREE_THRESHOLD = resolveFreeThreshold();
    var subCompare = 0;
    var lineTotal = 0;

    (cart.items || []).forEach(function (line) {
      var match = findLineMatch(line);
      var p = linePricing(line, match);
      subCompare += p.compare;
      lineTotal += p.price;
    });

    var bundleSave = Math.max(0, subCompare - lineTotal);
    var discApps = codeDiscountApps(cart);
    var discAmt = discountAmount(cart);
    var discLabel = discApps.length ? (discApps[0].title || '') : '';
    var total = cart.total_price != null ? cart.total_price : Math.max(0, lineTotal - discAmt);

    var hasBundle = (cart.items || []).some(function (line) {
      var match = findLineMatch(line);
      return match && match.tier && match.tier.free_ship;
    });
    var freeShip = hasBundle || total >= FREE_THRESHOLD;

    if (els.shipbar) {
      els.shipbar.style.width = (freeShip ? 100 : Math.min(100, Math.round(total / FREE_THRESHOLD * 100))) + '%';
    }
    if (els.shipmsg) {
      if (freeShip) {
        els.shipmsg.innerHTML = '<span class="hbcd-ship__unlocked">' +
          escapeHtml(t('ship_unlocked', "✓ You've unlocked FREE shipping!")).replace(/✓/g, '&#10003;') +
          '</span>';
      } else {
        var rem = money(Math.max(0, FREE_THRESHOLD - total));
        els.shipmsg.innerHTML = fillTpl(
          t('ship_remaining', "You're <b>[amount]</b> away from FREE shipping", ['amount']),
          { amount: rem }
        );
      }
    }

    var appliedDisc = hasAppliedDiscount(cart);
    if (els['disc-applied']) {
      if (appliedDisc) {
        els['disc-applied'].classList.add('hbcd-disc--applied-on');
        if (els['disc-text']) els['disc-text'].textContent = discountChipLabel(cart);
      } else {
        els['disc-applied'].classList.remove('hbcd-disc--applied-on');
      }
    }
    if (els['disc-toggle']) els['disc-toggle'].style.display = appliedDisc ? 'none' : '';

    if (els['lv-sub']) els['lv-sub'].textContent = money(subCompare);
    if (els['lr-bundle']) els['lr-bundle'].hidden = bundleSave <= 0;
    if (els['lv-bundle']) els['lv-bundle'].textContent = '-' + money(bundleSave);
    if (els['lr-disc']) els['lr-disc'].hidden = discAmt <= 0;
    if (discAmt > 0 && els['ll-disc']) {
      var discBase = t('discount_label', 'Discount');
      els['ll-disc'].textContent = discLabel ? discBase + ' (' + discLabel + ')' : discBase;
    }
    if (discAmt > 0 && els['lv-disc']) els['lv-disc'].textContent = '-' + money(discAmt);
    if (els['lv-ship']) {
      els['lv-ship'].innerHTML = freeShip
        ? '<span class="hbcd-lr__free">' + escapeHtml(t('ship_free', 'FREE')) + '</span>'
        : escapeHtml(t('ship_at_checkout', 'At checkout'));
    }
    if (els['r-tot']) els['r-tot'].textContent = money(total);
  }

  /* Upgrade only the clicked line. Merge qty if target variant already in cart.
     If the source line is a subscription, carry the target tier's selling_plan_id
     from Liquid (variant.selling_plan_allocations) — never hardcode plan IDs. */
  function doUpgrade(lineKey) {
    getCart().then(function (cart) {
      var sourceLine = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === lineKey) {
          sourceLine = cart.items[i];
          break;
        }
      }
      if (!sourceLine) return;

      var match = findLineMatch(sourceLine);
      var next = getNextTier(match);
      if (!next || !next.tier) return;

      var targetVariantId = next.tier.id;
      var sourceIsSub = lineHasSubscription(sourceLine);
      var targetPlanId = sourceIsSub && next.tier.selling_plan_id
        ? next.tier.selling_plan_id
        : null;

      var existingLine = null;
      for (var j = 0; j < cart.items.length; j++) {
        var cand = cart.items[j];
        if (cand.key === lineKey) continue;
        if (cand.variant_id != targetVariantId) continue;
        var candPlan = cand.selling_plan_allocation && cand.selling_plan_allocation.selling_plan
          ? cand.selling_plan_allocation.selling_plan.id
          : null;
        /* Only merge into a line with the same subscription state */
        if (targetPlanId) {
          if (candPlan == targetPlanId) {
            existingLine = cand;
            break;
          }
        } else if (!candPlan) {
          existingLine = cand;
          break;
        }
      }

      var btn = els.lines && els.lines.querySelector('.hbcd-upsell[data-line-key="' + lineKey + '"] [data-hbcd-upsell-btn]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = t('upsell_upgrading', 'Upgrading…');
      }

      state._upgrading = true;

      if (existingLine) {
        return cartFetch('cart/change.js', {
          id: existingLine.key,
          quantity: existingLine.quantity + sourceLine.quantity
        }).then(function () {
          return cartFetch('cart/change.js', { id: lineKey, quantity: 0 });
        });
      }

      var addItem = { id: targetVariantId, quantity: 1 };
      if (targetPlanId) addItem.selling_plan = targetPlanId;

      return cartFetch('cart/change.js', { id: lineKey, quantity: 0 }).then(function () {
        return cartFetch('cart/add.js', { items: [addItem] });
      });
    }).then(function () {
      state._upgrading = false;
      return fetchCart();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      state._upgrading = false;
      fetchCart();
    });
  }

  function changeQty(lineKey, qty) {
    getCart().then(function (cart) {
      var line = null;
      var lineIndex = -1;
      for (var i = 0; i < (cart.items || []).length; i++) {
        if (cart.items[i].key === lineKey) {
          line = cart.items[i];
          lineIndex = i + 1; /* Shopify line is 1-indexed */
          break;
        }
      }
      if (!line) return Promise.reject(new Error('line not found'));

      /* Use line index + keep selling_plan so qty updates do not drop the subscription. */
      var payload = { line: lineIndex, quantity: qty };
      if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
        payload.selling_plan = line.selling_plan_allocation.selling_plan.id;
      }
      return cartFetch('cart/change.js', payload);
    }).then(function () {
      return fetchCart();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      fetchCart();
    });
  }

  /* Event delegation on the lines container */
  if (els.lines) {
    els.lines.addEventListener('change', function (e) {
      var action = e.target.getAttribute('data-hb-offer-action');
      var row = e.target.closest('.hbcd-offer-line');
      if (!action || !row) return;
      changeOffer(row.getAttribute('data-line-key'), action, action === 'subscribe' ? e.target.checked : e.target.value);
    });
    els.lines.addEventListener('click', function (e) {
      if (offerBusy || offerBlocked || (window.HBOffer03Shipping && window.HBOffer03Shipping.busy())) return;
      var offerRow = e.target.closest('.hbcd-offer-line');
      if (offerRow) {
        var actionButton = e.target.closest('[data-hb-offer-action="upgrade"]');
        if (actionButton) { changeOffer(offerRow.getAttribute('data-line-key'), 'upgrade'); return; }
        var switchButton = e.target.closest('button[data-hb-offer-action="bundle"]');
        if (switchButton && !switchButton.disabled) { changeOffer(offerRow.getAttribute('data-line-key'), 'bundle', switchButton.getAttribute('data-hb-offer-target')); return; }
        var box = e.target.closest('[data-hb-offer-refills]');
        if (box && !e.target.closest('select,label,input')) {
          var checkbox = box.querySelector('input');
          if (!checkbox.disabled) changeOffer(offerRow.getAttribute('data-line-key'), 'subscribe', !checkbox.checked);
          return;
        }
      }

      var lineEl = e.target.closest('[data-line-key]');
      if (!lineEl) return;
      var lineKey = lineEl.getAttribute('data-line-key');

      if (e.target.closest('[data-hbcd-inc]')) {
        var qtyEl = lineEl.querySelector('.hbcd-qty__n');
        changeQty(lineKey, parseInt(qtyEl.textContent, 10) + 1);
        return;
      }
      if (e.target.closest('[data-hbcd-dec]')) {
        var qtyEl2 = lineEl.querySelector('.hbcd-qty__n');
        var next = parseInt(qtyEl2.textContent, 10) - 1;
        changeQty(lineKey, next < 1 ? 0 : next);
        return;
      }
      if (e.target.closest('[data-hbcd-rm]')) {
        changeQty(lineKey, 0);
        return;
      }
      if (e.target.closest('[data-hbcd-upsell-btn]')) {
        doUpgrade(lineKey);
      }
    });
  }

  /* Discount */
  if (els['disc-toggle']) {
    els['disc-toggle'].addEventListener('click', function () {
      if (els.disc) els.disc.classList.add('hbcd-disc--open');
      if (els['disc-input']) els['disc-input'].focus();
    });
  }

  function applyDiscount() {
    if (offerBusy || offerBlocked || (window.HBOffer03Shipping && window.HBOffer03Shipping.busy())) return;
    var input = els['disc-input'];
    if (!input) return;
    var code = input.value.trim();
    if (!code) return;

    clearDiscError();
    var applyBtn = els['disc-apply'];
    var applyLabel = applyBtn ? applyBtn.textContent : 'APPLY';
    if (applyBtn) {
      applyBtn.disabled = true;
      applyBtn.textContent = t('disc_applying', 'Applying…');
    }

    cartFetch('cart/update.js', { discount: code }).then(function (cart) {
      var invalid = (cart.discount_codes || []).some(function (d) {
        return d.code.toLowerCase() === code.toLowerCase() && !d.applicable;
      });

      if (invalid) {
        showDiscError();
        return cartFetch('cart/update.js', { discount: '' });
      }

      if (els.disc) els.disc.classList.remove('hbcd-disc--open');
      input.value = '';
      state.cart = cart;
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return cart;
    }).catch(function () {
      showDiscError();
    }).finally(function () {
      if (applyBtn) {
        applyBtn.disabled = false;
        applyBtn.textContent = applyLabel;
      }
    });
  }

  function clearDiscountCookie() {
    return fetch(CART_ROOT + 'discount/', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function () {});
  }

  function removeDiscount() {
    if (offerBusy || offerBlocked || (window.HBOffer03Shipping && window.HBOffer03Shipping.busy())) return;
    clearDiscError();
    var rmBtn = els['disc-rm'];
    if (rmBtn) rmBtn.disabled = true;

    getCart().then(function (cart) {
      var apps = codeDiscountApps(cart);
      var removeTitle = apps.length ? apps[0].title : '';
      var remaining = (cart.discount_codes || [])
        .filter(function (d) { return d.applicable; })
        .map(function (d) { return d.code; })
        .filter(function (code) {
          return !removeTitle || code.toLowerCase() !== removeTitle.toLowerCase();
        });

      return cartFetch('cart/update.js', { discount: remaining.join(',') });
    }).then(function (cart) {
      if (hasAppliedDiscount(cart)) {
        return cartFetch('cart/update.js', { discount: '' });
      }
      return cart;
    }).then(function () {
      return clearDiscountCookie();
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      state.cart = cart;
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cart, baseEvent: 'discount:remove' }
      }));
    }).catch(function () {
      fetchCart();
    }).finally(function () {
      if (rmBtn) rmBtn.disabled = false;
    });
  }

  if (els.disc) {
    els.disc.addEventListener('click', function (e) {
      if (e.target.closest('[data-hbcd-disc-rm]')) {
        e.preventDefault();
        e.stopPropagation();
        removeDiscount();
        return;
      }
      if (e.target.closest('[data-hbcd-disc-apply]')) {
        e.preventDefault();
        applyDiscount();
      }
    });
  }

  if (els['disc-input']) {
    els['disc-input'].addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });
    els['disc-input'].addEventListener('input', clearDiscError);
  }

  if (els.co) {
    els.co.addEventListener('click', function () {
      if (!offerBusy && !offerBlocked && !(window.HBOffer03Shipping && window.HBOffer03Shipping.busy())) window.location.href = CHECKOUT_URL;
    });
  }
  if (els.eshop) {
    els.eshop.addEventListener('click', function () { close(); window.location.href = EMPTY_SHOP_URL; });
  }
  if (els['empty-shop']) {
    els['empty-shop'].addEventListener('click', function () { close(); window.location.href = EMPTY_SHOP_URL; });
  }

  function isCartHref(href) {
    if (!href) return false;
    try {
      var path = href.indexOf('://') > -1 ? new URL(href, window.location.origin).pathname : href;
      return /\/cart\/?$/.test(path.split('?')[0].split('#')[0]);
    } catch (_) {
      return /\/cart\/?(\?|#|$)/.test(href);
    }
  }

  function findCartTrigger(target) {
    if (!target || !target.closest) return null;

    var trigger = target.closest('[aria-controls="cart-drawer"]');
    if (trigger) return trigger;

    trigger = target.closest('a[href]');
    if (trigger && isCartHref(trigger.getAttribute('href'))) return trigger;

    var zone = target.closest('.header__cart-link, hb-bag-nudge, .footer__go-to-cart');
    if (zone) {
      trigger = zone.querySelector('[aria-controls="cart-drawer"]') ||
        zone.querySelector('a[href*="/cart"]');
      if (trigger) return trigger;
    }

    if (target.closest('cart-count, .header__cart-count-badge')) {
      zone = target.closest('.header__cart-link');
      if (zone) {
        return zone.querySelector('[aria-controls="cart-drawer"]') ||
          zone.querySelector('a[href*="/cart"]');
      }
    }

    return null;
  }

  function suppressThemeCartDrawer() {
    var themeDrawer = document.getElementById('cart-drawer');
    if (!themeDrawer) return;
    if (themeDrawer.hide) try { themeDrawer.hide(); } catch (_) {}
    themeDrawer.removeAttribute('open');
  }

  function interceptCartClicks() {
    document.addEventListener('click', function (e) {
      var trigger = findCartTrigger(e.target);
      if (!trigger) return;
      if ((window.location.pathname || '').replace(/\/$/, '') === '/cart') return;
      if (e.ctrlKey || e.metaKey || e.button === 1) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      suppressThemeCartDrawer();
      document.documentElement.classList.remove('lock');
      open();
    }, true);
  }

  function onCartEvent(event) {
    if (state._upgrading) {
      fetchCart();
      return;
    }
    var base = event.detail && event.detail.baseEvent;
    if (base === 'discount:remove') return;
    if (event.type === 'cart:change' && base === 'variant:add') {
      /* Stop the theme drawer from opening underneath HB (empty flash). */
      suppressThemeCartDrawer();
      openAfterAdd(event.detail && event.detail.cart);
      return;
    }
    if (root.classList.contains('hbcd-on') && (event.type === 'cart:refresh' || event.type === 'cart:change')) {
      fetchCart();
    }
  }

  document.addEventListener('cart:change', onCartEvent, true);
  document.addEventListener('cart:refresh', onCartEvent);
  document.addEventListener('hb-offer:checkout-state', function () { if (state.cart) render(state.cart); });

  interceptCartClicks();

  window.HBCartDrawer = { open: open, close: close, refresh: fetchCart, openAfterAdd: openAfterAdd };
})();
